import { render, staticRenderFns } from "./LiveDealsComponent.vue?vue&type=template&id=0e20ca9f&scoped=true&"
import script from "./LiveDealsComponent.vue?vue&type=script&lang=ts&"
export * from "./LiveDealsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LiveDealsComponent.vue?vue&type=style&index=0&id=0e20ca9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20ca9f",
  null
  
)

export default component.exports